export default __webpack_public_path__ + "static/media/G1LS_150.b418c61a.jpg";